import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import {
  getEventDateValue,
  sortEventsForList,
} from '../utils/eventListFilters';
//import {getMProjectsById} from "../reducers/index";


//Action Creators
export const loadMEventsStart = (id) => {
  return {
    type: actionTypes.MEVENTS_LOAD_START,
    id,
  };
};
export const loadMEventsFail = (id, error) => {
  console.error(error);
  return {
    type: actionTypes.MEVENTS_LOAD_FAIL,
    id,
    error,
  };
};
export const loadMEventsSuccess = (data) => {
  return {
    type: actionTypes.MEVENTS_LOAD_SUCCESS,
    data,
  };
};

export const initMEvents = () => dispatch => {
  dispatch(loadMEventsStart());


  const mEvents = {
    title: 'example mEventsActions title',
    description: 'example mEventsActions description',
  };

  // Load the full catalog (not future-only) so empty date filters + search cover every event.
  // High limit avoids Strapi's default page hiding newer entries among older ones (LLSU2-123).
  const eventsQuery = {
    _limit: 200,
    _sort: 'EventDate:desc',
  };

  return Promise.all([
      apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, eventsQuery),
      apiActions.loadEndpoint(apiValues.nref.program.endpoint, null),
      apiActions.loadEndpoint(apiValues.nref.category.endpoint, null),
    ])
    .then(([events, programs, categories]) => {
      const eventResults = sortEventsForList(
        (events || []).filter(item => getEventDateValue(item)),
      );

      mEvents.events = apiActions.arraySelectCamelCaseKeys(eventResults, apiValues.nref.event.fieldsUsed);
      mEvents.programs = programs ? apiActions.arraySelectCamelCaseKeys(programs, apiValues.nref.program.fieldsUsed) : undefined;
      mEvents.categories = categories ? apiActions.arraySelectCamelCaseKeys(categories, apiValues.nref.category.fieldsUsed) : undefined;

      dispatch(loadMEventsSuccess(mEvents));
      return mEvents;
    });

};


